module.exports = __webpack_public_path__ + "img/download-docuement.20a0c834.svg";